import React from 'react';
import {useState} from 'react';
import ClipModalTimeInfo from './ClipModalTimeInfo';
import ClipModalUserInfo from './ClipModalUserInfo';
import ClipModalCancel from './ClipModalCancel';
import ClipModalShare from './ClipModalShare';
import { IoMdClose } from "react-icons/io";
import pfp from './pfp.png';


function ClipModal({setOpenClipModal}) {

    const[openCancelModal, setOpenCancelModal] = useState(false);
    const[openShareModal, setOpenShareModal] = useState(false);

    return (
      <div>
        <div className="h-96 flex justify-center w-96 inline-block bg-gradient-to-b from-zinc-800 to-custom-black shadow-2xl rounded-xl mx-2">
          <div className="w-10/12 flex flex-col justify-around">
            <div className="flex w-full items-center justify-between">
              <div className="text-white text-lg font-bold">
                Create clip
              </div>
              <div
                className="text-white cursor-pointer text-xl"
                onClick={() => {
                  setOpenClipModal(false);
                }}
              >
                <IoMdClose />
              </div>
            </div>
            <ClipModalUserInfo
              pfp={pfp}
              username="Ravi"
            />
            <input placeholder="Add a description (required)"
              className="bg-transparent placeholder-gray-500 border-b-2 border-zinc-700 font-medium w-full flex justify-center items-center h-10 text-white"
              type="text"
              maxLength={140}
             />
            <ClipModalTimeInfo
              startTime="1:10:04"
              endTime="1:10:40"
            />
            <div className="w-full h-12 bg-black">
            </div>
            <div className="flex justify-end items-center w-full">
              <div
                className="text-zinc-400 cursor-pointer hover:text-blue-400 mr-6"
                onClick={() => {
                  setOpenCancelModal(true);
                  setOpenShareModal(false);
                }}
              >
                Cancel
              </div>
              <div
                className="w-24 rounded-xl h-10 bg-gradient-to-br from-zinc-600 to-zinc-800 flex items-center text-white justify-center px-2 cursor-pointer"
                onClick={() => {
                  setOpenShareModal(true);
                  setOpenCancelModal(false);
                }}
              >
                Share Clip
              </div>
            </div>
          </div>
        </div>
          {openCancelModal && <ClipModalCancel setOpenCancelModal={setOpenCancelModal} setOpenClipModal={setOpenClipModal} />}
          {openShareModal && <ClipModalShare setOpenShareModal={setOpenShareModal} />}
        </div>
    );
}

export default ClipModal;
